import { AlertCircle, Pencil, Eye, EyeOff } from 'lucide-react'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { FaRegEdit } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { UserInfo } from '../../contexts/allContext'
import { homeUrl } from '../../utils/api'
import { svgs } from '../../utils/findSvgs/findSvgs'
import { convertDate } from '../../utils/static/convertDate'
import { getShopShortName } from '../../utils/static/getShopShortName'
import { filterInventoryType, filterSortOptions } from '../../utils/static/static'
// import Popup from '../Product/view/ProductList/Popup/Popup'
import Searchbar from '../Product/view/ProductList/Searchbar/Searchbar'
import SkeletonLoader from '../Resources/SkeletonLoader/SkeletonLoader'
import TitleContainer from '../Resources/TitleContainer/TitleContainer'
import InventoryCard from './Cards/InventoryCard'
import classes from './InventoryList.module.css'
import PopUp from './PopUp/PopUp'
import VariantTable from './Table/VariantTable'

const InventoryList = ({
    products,
    filters,
    setFilters,
    setPage,
    loading,
    search,
    setSearch,
    page,
    limit,
    productData,
}) => {
    const [meta, data] = products
    console.log(products)
    const { stateUser } = useContext(UserInfo)
    const userInfo = stateUser.info
    const [showVariants, setShowVariants] = useState(null)
    // for filters...

    const handleFilterChange = (label) => {
        setFilters((prev) => ({
            ...prev,
            all: false,
            [label]: filters[label] ? false : true,
        }))
    }

    const resetAll = () => {
        setFilters(() => ({
            ...filters,
            all: true,
            showAll: true,
            retail: false,
            wholesale: false,
            active: true,
            search: '',
            variant: '',
            feature: '',
            lowStock: '',
            outOfStock: '',
        }))
        setSearch((prev) => ({
            ...prev,
            value: '',
            isSearchAble: false,
        }))
    }

    useEffect(() => {
        if (filters.retail || filters.wholesale) {
            setFilters((prev) => ({ ...prev, showAll: false }))
        } else {
            setFilters((prev) => ({ ...prev, showAll: true, all: true }))
        }
    }, [filters.retail, filters.wholesale])

    useEffect(() => {
        if (!filters.retail && !filters.wholesale && !filters.outOfStock && !filters.outOfStock) {
            setFilters((prev) => ({ ...prev, showAll: true, all: true }))
        }
    }, [filters.retail, filters.wholesale, filters.outOfStock, filters.lowStock])

    // for sorting...
    const onChange = (value) => {
        setFilters(() => ({ ...filters, sortBy: value }))
    }

    useEffect(() => {
        if (data?.length <= 0) {
            setPage(0)
        }
    }, [data])

    const handleShowVarinats = (productId) => {
        if (productId === showVariants) {
            return setShowVariants(null)
        }
        setShowVariants(productId)
    }

    function removeSpace(str) {
        return str.trim().toLowerCase().replace(/\s+/g, '-')
    }

    return (
        <>
            <div className={classes.container}>
                {/* Top Search Bar */}
                <Searchbar search={search} setSearch={setSearch} />

                {/* Filters Row */}
                <div className={classes.filtersRow}>
                    <div className={classes.formBox}>
                        <div className={classes.checkboxes}>
                            <div className={`${filters.all ? classes.active : ''}`} onClick={() => resetAll()}>
                                <div>{svgs.selectIcon}</div>
                                <label>All</label>
                            </div>
                            {filterInventoryType.map((type) => {
                                const isActive = Object.keys(filters).some((key) => key === type.label && filters[key])

                                return (
                                    <div
                                        key={type.id}
                                        className={`${isActive ? classes.active : ''}`}
                                        onClick={() => handleFilterChange(type.label)}>
                                        <div>{svgs.selectIcon}</div>
                                        <label>{type.value}</label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className={classes.sortContainer}>
                        <PopUp
                            options={filterSortOptions}
                            parentClass={'sortContainer'}
                            defaultValue={''}
                            placeholder={'Sort By'}
                            filters={filters}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <TitleContainer title={'Product List'} isCount={true} count={products[0]?.results} />
            </div>

            {/* Table Section */}
            <div className={classes.tableContainer}>
                <table className={classes.table}>
                    <thead>
                        <tr>
                            <th>SL</th>
                            <th>SKU</th>
                            <th>Product</th>
                            <th>Shop Name</th>
                            <th>Category</th>
                            <th>B2C Price</th>
                            <th>B2B Price</th>
                            <th>Total Stock</th>
                            <th>Variant</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <SkeletonLoader row={10} column={11} />
                        ) : data?.length > 0 ? (
                            data?.map((item, index) => {
                                const { Product, ProductInventory, ImgProduct, ProductPrice, Category, Seller } = item
                                const shortName = getShopShortName(userInfo?.name)
                                const { product_variants: variants } = Product
                                let stockOutVariantsLength =
                                    variants.length > 0 ? variants.filter((variant) => variant.quantity < 10).length : 0
                                return (
                                    <>
                                        <tr key={index}>
                                            <td>{page * limit + (index + 1)}</td>
                                            <td className={classes.productDetails}>
                                                {shortName}
                                                {ProductInventory.sku}
                                            </td>
                                            <td>
                                                <div className={classes.productCell}>
                                                    <img
                                                        src={ImgProduct.image_url}
                                                        alt={Product.title}
                                                        className={classes.productImage}
                                                    />
                                                    <Link
                                                        to={`${homeUrl}/products/${
                                                            Product?.product_full_id
                                                        }/${removeSpace(Product.title)}`}
                                                        target="_blank">
                                                        <span className={classes.productTitle}>{Product.title}</span>
                                                    </Link>
                                                </div>
                                            </td>
                                            <td>
                                                <Link
                                                    to={`${homeUrl}/companies/${Seller.seller_full_id}/${removeSpace(
                                                        Seller.page_name
                                                    )}`}
                                                    className={classes.productShop}
                                                    target="_blank">
                                                    {Seller.page_name}
                                                </Link>
                                            </td>
                                            <td>{Category.name}</td>
                                            <td>{Product.is_retail ? ProductPrice.final_retail_price : '--'}</td>
                                            <td>{Product.is_wholesale ? ProductPrice.final_wholesale_price : '--'}</td>
                                            <td>
                                                <div className={classes.stock}>
                                                    {ProductInventory.quantity}
                                                    {stockOutVariantsLength > 0 ? (
                                                        <div>
                                                            <AlertCircle />
                                                            <span className={classes.stockStatus}>
                                                                {stockOutVariantsLength > 0 &&
                                                                    `${stockOutVariantsLength} variant Alert`}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        ProductInventory.quantity < 10 && (
                                                            <div>
                                                                <AlertCircle />
                                                                <span className={classes.stockStatus}>
                                                                    {ProductInventory.quantity > 0
                                                                        ? 'Low Stock'
                                                                        : 'Stock Out'}
                                                                </span>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                {' '}
                                                <div className={classes.statusContainer}>
                                                    <span
                                                        className={
                                                            ProductInventory?.is_variant
                                                                ? classes.statusCircleavailable
                                                                : classes.statusCircle
                                                        }></span>
                                                    {ProductInventory?.is_variant ? 'Available' : 'Unavailable'}
                                                </div>
                                            </td>
                                            <td>
                                                <span
                                                    className={`${classes.status} ${
                                                        Product?.is_active ? classes.active : classes.pending
                                                    }`}>
                                                    {Product?.is_active ? 'Active' : 'Pending'}
                                                </span>
                                            </td>
                                            <td>{convertDate(Product?.created_at)}</td>
                                            <td>
                                                <div className={classes.actionButton}>
                                                    <Link to={`/products/edit/${Product.id}`} target="_blank">
                                                        <FaRegEdit size={15} />
                                                    </Link>
                                                    {variants.length > 0 && (
                                                        <div
                                                            onClick={() => handleShowVarinats(Product.id)}
                                                            className={classes.iconBtn}>
                                                            {showVariants === Product.id ? (
                                                                <EyeOff size={15} />
                                                            ) : (
                                                                <Eye size={15} />
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        {showVariants === Product.id && variants.length > 0 && (
                                            <tr>
                                                <td colSpan={11}>
                                                    <VariantTable
                                                        variants={variants}
                                                        productData={productData}
                                                        product={Product}
                                                    />
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan="10" className={classes.tableNotFound}>
                                    <h2>No Data Found</h2>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default InventoryList
